import VuiTypography from "components/VuiTypography";
import { Table } from "modules/dashboard/components/table.component";
import { useState } from "react";
import { AppSaleState } from "./sales-state.components";

export function AppSalesTable({ 
  salesTableRows, 
  salesTableColumns, 
  codesButtonStates,
  fetchSales 
}) {
  const [oderByKey, setOrderByKey] = useState("");
  const [oderByType, setOrderByType] = useState("");

  const handleChangeSort = (newOrderByKey, newOrderByType) => {
    if (newOrderByKey === oderByKey && newOrderByType === oderByType) {
      setOrderByKey("");
      setOrderByType("");
    } else {
      setOrderByKey(newOrderByKey);
      setOrderByType(newOrderByType);
    }
    fetchSales({
      key: "order",
      value: newOrderByKey + "-" + newOrderByType,
      clear: newOrderByKey === oderByKey && newOrderByType === oderByType,
    });
  };

  return (
    <Table
      columns={salesTableColumns.map((item) => ({
        ...item,
        property: item.property,
        label: (
          <VuiTypography
            color="white"
            sx={{
              display: "flex",
              alignItems: "center",
              fontSize: "14px",
              fontWeight: "400",
            }}
          >
            {item.label}
          </VuiTypography>
        ),
        responsive: item.responsive,
        align: "left",
        styles: item.styles,
        dropDownName: item.label,
      }))}
      rows={salesTableRows.map((item) => ({
        ...item,
        id: item.challengeOrderId,
        lastName: {
          default: (
            <VuiTypography
              color="white"
              sx={{
                fontSize: "12px",
                lineHeight: "15.6px",
                fontWeight: "500",
                padding: "8px"
              }}
            >
              {item.lastName.default ?? item.defaultValue}
            </VuiTypography>
          ),
        },
        countryId: {
          default: (
            <VuiTypography
              color="white"
              sx={{
                fontSize: "12px",
                lineHeight: "15.6px",
                fontWeight: "500",
              }}
            >
              {item.countryId.default ?? item.defaultValue}
            </VuiTypography>
          ),
        },
        paymentDate: {
          default: (
            <VuiTypography
              color="white"
              sx={{
                fontSize: "12px",
                lineHeight: "15.6px",
                fontWeight: "500",
              }}
            >
              {item.paymentDate.default ?? item.defaultValue}
            </VuiTypography>
          ),
        },
        description: {
          default: (
            <VuiTypography
              color="white"
              sx={{
                fontSize: "12px",
                lineHeight: "15.6px",
                fontWeight: "500",
              }}
            >
              {item.description.default ?? item.defaultValue}
            </VuiTypography>
          ),
        },
        balance: {
          default: (
            <VuiTypography
              color="white"
              sx={{
                fontSize: "12px",
                lineHeight: "15.6px",
                fontWeight: "500",
              }}
            >
              {item.balance.default ?? item.defaultValue}
            </VuiTypography>
          ),
        },
        email: {
          default: (
            <VuiTypography
              color="white"
              sx={{
                fontSize: "12px",
                lineHeight: "15.6px",
                fontWeight: "500",
              }}
            >
              {item.email.default ?? item.defaultValue}
            </VuiTypography>
          ),
        },
        mt5AccountBalance: {
          default: (
            <VuiTypography
              color="white"
              sx={{
                fontSize:"12px",
                lineHeight: "15.6px",
                fontWeight: "500",
              }}
            >
              {item.mt5AccountBalance.default ?? item.defaultValue}
            </VuiTypography>
          )
        },
        partnerBenefitAmount: {
          default: (
            <VuiTypography
              color="white"
              sx={{
                fontSize:"12px",
                lineHeight: "15.6px",
                fontWeight: "500",
              }}
            >
              {item.partnerBenefitAmount.default ?? item.defaultValue}
            </VuiTypography>
          )
        },
        grade: {
          default: <AppSaleState state={item.grade} codesButtonStates={codesButtonStates} />,
          special: (
            <AppSaleState
              state={item.grade}
              codesButtonStates={codesButtonStates}
              responsive={false}
            />
          ),
        }
      }))}
      handleChangeSort={handleChangeSort}
      oderByKey={oderByKey}
      oderByType={oderByType}
    />
  );
}
